export default __webpack_public_path__ + "static/cs-deloitte-3d7dd1a97745278f08c11b87cbb8baf6.png";